export enum LmiDocumentValidationMessageKey {
  DocumentValid = 'document_valid',
  InvalidData = 'invalid_data',
  InvalidDocument = 'invalid_document',
  PoorImageQuality = 'poor_image_quality',
  WrongLmiDocumentType = 'wrong_lmi_document_type',
  LmiNameMismatch = 'lmi_name_mismatch',
  ExpiredLmiDocument = 'expired_lmi_document',
  ManualReviewRequired = 'manual_review_required',
  ValidationUnavailable = 'validation_unavailable',
}

const validationUnavailableMessage =
  'We could not validate this document right now. You can continue, but this may need review.';

const validationMessages = new Map<LmiDocumentValidationMessageKey, string>([
  [LmiDocumentValidationMessageKey.DocumentValid, 'Document is valid.'],
  [LmiDocumentValidationMessageKey.InvalidData, 'Document is missing required name or date.'],
  [LmiDocumentValidationMessageKey.InvalidDocument, 'Document needs additional review.'],
  [LmiDocumentValidationMessageKey.PoorImageQuality, 'Document is blurry or poor image quality.'],
  [
    LmiDocumentValidationMessageKey.WrongLmiDocumentType,
    'Document needs additional review, document does not appear to match the program selected.',
  ],
  [LmiDocumentValidationMessageKey.LmiNameMismatch, 'Document name needs review.'],
  [LmiDocumentValidationMessageKey.ExpiredLmiDocument, 'Document is expired.'],
  [
    LmiDocumentValidationMessageKey.ManualReviewRequired,
    'This document may need review, but you can continue.',
  ],
  [LmiDocumentValidationMessageKey.ValidationUnavailable, validationUnavailableMessage],
]);

const isLmiDocumentValidationMessageKey = (key: string): key is LmiDocumentValidationMessageKey =>
  validationMessages.has(key as LmiDocumentValidationMessageKey);

export const getLmiDocumentValidationMessage = (key: string): string => {
  if (isLmiDocumentValidationMessageKey(key)) {
    return validationMessages.get(key)!;
  }

  return validationUnavailableMessage;
};
